import { getType } from 'typesafe-actions';
import * as actions from '../actions';
import * as Sentry from '@sentry/react';
import { setSentryIsAdmin } from '../../utils/functions/sentryUtils';
import { EROLES } from '../../utils/constants/roles.enum';

export const defaultState = {
  user: {},
  isTimeout: false,
  walletRegisterRequest: false,
  authGate: null, // SPEC-2026-06-29-auth-confirm-2fa.v1 : { type, hasEmail?, thresholdUsd? } | null
};

const states = (state = defaultState, action) => {
  switch (action.type) {
    case getType(actions.setUser): {
      const userId = action.payload?.id;
      // Sentry user scope — identifiant interne uniquement (jamais email/wallet PII)
      if (userId) {
        Sentry.setUser({ id: String(userId) });
        // Tag is_admin pour filtrer les erreurs admin vs user (roleId 1 = ADMIN)
        setSentryIsAdmin(action.payload?.roleId === EROLES.ADMIN);
      } else {
        // logout ou reset (setUser({}) / setUser(null))
        Sentry.setUser(null);
        setSentryIsAdmin(false);
      }
      return { ...state, user: action.payload };
    }
    case getType(actions.setIsTimeout):
      return { ...state, isTimeout: action.payload};

    case getType(actions.setWalletRegisterRequest):
      return { ...state, walletRegisterRequest: action.payload};

    case getType(actions.setAuthGate):
      return { ...state, authGate: action.payload};

    default:
      return state;
  }
};

export default states;
